<template>
    <div
        class="py-10 bg-contain"
        :style="{
            backgroundImage: `url('${require('@/assets/img/fondo_control_icons.png')}')`,
            backgroundColor: '#ff8900'
        }"
    >
        <h2
            class="font-primary text-center text-3xl text-white mb-10"
            :class="titleClass"
        >
            {{ $config("JUEGOS") }}
        </h2>

        <div class="w-full max-w-screen-xl mx-auto">
            <slider
                :options="sliderOptions"
                :items="games"
                nav-class="hidden sm:block"
            >
                <template v-slot="{ item: game }">
                    <div class="flex flex-col w-11/12 mx-auto mb-10 sm:mb-0">
                        <router-link
                            :to="{ name: 'game', params: { id: game.id } }"
                            :alt="game.name"
                        >
                            <app-image
                                width="370"
                                height="208"
                                :alt="game.name"
                                :url="game.preview"
                                class="rounded-t-lg"
                                lazy
                            >
                            </app-image>
                        </router-link>

                        <div
                            class="flex relative items-center rounded-b-lg py-3 px-4 bg-green"
                        >
                            <app-image
                                url="juegos.svg"
                                is-local
                                class="game-icon w-20 right-0 absolute"
                                :alt="game.name"
                            ></app-image>

                            <p
                                class="font-primary text-xl text-white"
                                :alt="game.name"
                            >
                                {{ game.name }}
                            </p>
                        </div>
                    </div>
                </template>
            </slider>
        </div>
    </div>
</template>

<script>
import Slider from "./Slider";

export default {
    name: "games-section",

    components: { Slider },

    props: {
        games: {
            type: Array,
            required: true,
            default: () => []
        },

        titleClass: {
            type: String,
            default: ""
        }
    },

    data() {
        return {
            sliderOptions: {
                slidesPerView: 1,
                slidesPerColumn: 100,
                breakpoints: {
                    576: {
                        slidesPerView: 1,
                        slidesPerColumn: 0
                    },
                    992: {
                        slidesPerView: 3,
                        slidesPerColumn: 0
                    }
                }
            }
        };
    }
};
</script>

<style scoped>
.game-icon {
    top: -35px;
}
</style>
